<template>
  <div class="question__indicator">
    <!-- {{questions}} -->
    <!-- {{resultsForDebugging}} -->
    <div class="question__left">
      {{ questionsLeft }} more question<span v-if="questionsLeft > 1">s</span> to unlock custom recommendations
    </div>
    <ul>
      <li v-for="(q, index) in questions" :key="index">
        <button
          type="button"
          @click="navigateQuestions(q.index)"
          :disabled="disabledIds.includes(q.id)"
          :class="{ 'active': q.id === qid, 'not-answered': !answered(q.key) }"
        >
        <span>
          {{ q.id }}
        </span>
          <!-- {{ q.index }} {{ qid }} {{ q.key }} -->
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Indicator",
  props: {
    qid: {
      type: String,
      default: ''
    },
  },
  computed: {
    questions() {
      return this.$store.getters.questionsActual
    },
    questionsLeft() {
      return this.questions.length - this.currentQuestion.index
    },
    resultsForDebugging() {
      return this.$store.state.quiz
    },
    currentQuestion() {
      return this.questions.find((q) => {
        return q.id === this.qid
      })
    },
    nextQuestion() {
      let nq
      for(let i = 0 ; i < this.questions.length ; i++) {
        if (this.questions[i].id === this.qid) {
          nq = this.questions[i + 1]
        }
      }
      return nq
    },
    disabledIds() {
      //       console.log(this.nextQuestion, id)
      // if (!this.answered(key)) {
      //   return (id == this.qid) ? false : true
      // }
      let disabled = []
      // add everything after
      this.questions.map((q) => {
        // console.log(q.key, this.answered(q.key))
        // if (!this.answered(q.key)) {
        if (typeof this.currentQuestion !== 'undefined') {
          if (q.index > this.currentQuestion.index) {
            disabled.push(q.id)
          }
        }
      })
      // if its the next question, remove it
      // if (disabled.includes(this.nextQuestion.id)) {
      //   disabled.splice(disabled.indexOf(this.nextQuestion.id), 1)
      // }
      // if it's the current question, remove it
      if (disabled.includes(this.qid)) {
        disabled.splice(disabled.indexOf(this.qid), 1)
      }
      // return this.nextQuestion.id === id ? false : true
      // console.log('disabled', disabled)
      return disabled
    }
  },
  methods: {
    navigateQuestions(index) {
      if (typeof dataLayer === 'object') {
				// eslint-disable-next-line
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'OCS Engagement',
					eventAction: 'click',
					eventLabel: 'Question Indicator | ' + index,
				});
			}
      this.$store.dispatch('setTimeline', index)
    },
    answered(key) {
      if (typeof this.resultsForDebugging[key] !== 'undefined' && this.resultsForDebugging[key] !== null) {
        if (this.resultsForDebugging[key].length > 0 || typeof this.resultsForDebugging[key] === "boolean") {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss">

.question__indicator {
  position: absolute;
  bottom: 4%;
  left: 0;
  right: 0;
  z-index: map-get($z, 3);
  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    li {
      button {
        @include button-reset;
        width: 1em;
        height: 1em;
        border-radius: 0.5em;
        margin: 0.333em;
        background-color: $green;
        span {
          @include visually-hidden;
        }
        &:disabled {
          background-color: $lgray;
          /* opacity: 0.333; */
        }
        &.active {
          background-color: transparent;
          border: 3px solid $green;
        }
        &:not(.active):not(:disabled) {
          &:hover {
            background-color: $green-hover;
          }
        }
      }
      &:last-child {
        button {
          background-color: $lgray;
          &.active {
            background-color: $green;
          }
        }
      }
    }
  }
  @include breakpoint(large) {
    bottom: 1%;
    ul {
      li {
        button {
          width: 1.4em;
          height: 1.4em;
          border-radius: 0.7em;
          margin: 0.5em;
        }
      }
    }
  }
}

.question__left {
  font-family: $serif;
  font-weight: 700;
  font-size: em(14);
  text-align: center;
  color: #59ac40;
  text-align: center;
}

</style>